// extracted by mini-css-extract-plugin
module.exports = {"container":"BookingsInsights_container__1v8Os","mobileWrapper":"BookingsInsights_mobileWrapper__1rap4","description":"BookingsInsights_description__Q7r6e"};